import { useCallback } from 'react';
import { useQueryClient } from '../../lib';
import { getFeedKey, getPostKey, getPostsKey } from '../../utils/keys';
export const useInvalidatePostQuery = () => {
    const queryClient = useQueryClient();
    const invalidate = useCallback((postId) => {
        const postKey = getPostKey({ variables: { id: postId } });
        queryClient.invalidateQueries(postKey);
        const postsKey = getPostsKey();
        queryClient.invalidateQueries(postsKey);
        const feedKey = getFeedKey();
        queryClient.invalidateQueries(feedKey);
    }, [queryClient]);
    return invalidate;
};
//# sourceMappingURL=useInvalidatePostQuery.js.map